module.exports = __webpack_public_path__ + "static/img/fujin.cf96818.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fujin.png
// module id = 9Tw6
// module chunks = 52